// extracted by mini-css-extract-plugin
module.exports = {"whiteCard":"_3D60D"};